import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { ReferralShareDialogContentContainer } from '@/features/points/dialogs/referral-share-dialog/ReferralShareDialogContentContainer'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

interface ReferralShareDialogProps extends CommonDialogProps {}

function ReferralShareDialog({ open, setOpen }: ReferralShareDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent spacing="none">
        <ReferralShareDialogContentContainer />
      </DialogContent>
    </Dialog>
  )
}

export const referralShareDialogConfig: DialogConfig<ReferralShareDialogProps> = {
  options: {
    closeOnAccountChange: false,
  },
  element: ReferralShareDialog,
  name: 'ReferralShareDialog',
}
